import { SuperAdminConstants } from '../../../_constants';

const initialState = { getOrgAdminsLoading: true, data: '', error: false };

export function getOrgAdmins(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ORG_ADMINS:
            return {
                getOrgAdminsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ORG_ADMINS:
            return {
                getOrgAdminsLoading: false,
                data: action.getOrgAdmins,
                error: false
            };
        case SuperAdminConstants.GET_ORG_ADMINS_ERROR:
            return {
                getOrgAdminsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageOrgAdmins/getOrgAdmins.reducer.js